export default "__VITE_ASSET__DjpdNuIw__"